import { NotificationRegistryRead } from "@/services/generatedApi";
import { Loader } from "@/ui-components/Loader";
import { NotificationsFooter } from "@/ui-components/components/UserMenu/components/NotificationsFooter";
import { NotificationsHeader } from "@/ui-components/components/UserMenu/components/NotificationsHeader";
import { NotificationsListBody } from "@/ui-components/components/UserMenu/components/NotificationsListBody";
import { NotificationsTabs } from "@/ui-components/components/UserMenu/components/NotificationsTabs";
import { groupByDate } from "@/ui-components/components/UserMenu/components/utils";
import { Box, Button } from "@mui/material";
import * as React from "react";
import { useTranslation } from "react-i18next";

type NotificationListProps = {
  notifications: NotificationRegistryRead[];
  markAsRead: (id: number) => void;
  markAllAsRead: () => void;
};

export const NotificationList: React.FC<NotificationListProps> = ({ notifications, markAsRead, markAllAsRead }) => {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = React.useState("Application");
  const [onlyUnread, setOnlyUnread] = React.useState(false);
  if (!notifications) {
    return <Loader />;
  }

  const list = notifications
    .filter(notification => notification.notification_body.event_type === selectedTab)
    .filter(notification => !onlyUnread || !notification.dismissed_at);

  const { today, yesterday, lastWeek, older } = groupByDate(list);
  return (
    <Box sx={{ width: "600px" }}>
      <NotificationsHeader onlyUnread={onlyUnread} setOnlyUnread={setOnlyUnread} />
      <NotificationsTabs selectedTab={selectedTab} setSelectedTab={setSelectedTab} />
      <Box sx={{ height: "360px", overflow: "auto" }}>
        <div className="flex items-center justify-end absolute w-full">
          <Button
            variant="text"
            onClick={markAllAsRead}
            style={{
              padding: "13px 24px 14px 16px",
            }}
          >
            {t("notifications.Mark_all_as_read")}
          </Button>
        </div>
        <NotificationsListBody notifications={today} header={t("notifications.Today")} markAsRead={markAsRead} />
        <NotificationsListBody
          notifications={yesterday}
          header={t("notifications.Yesterday")}
          markAsRead={markAsRead}
        />
        <NotificationsListBody notifications={lastWeek} header={t("notifications.Last_Week")} markAsRead={markAsRead} />
        <NotificationsListBody notifications={older} header={t("notifications.Older")} markAsRead={markAsRead} />
        <NotificationsFooter />
      </Box>
    </Box>
  );
};
